import Axios from "../../../_helpers/axiosHelper";
import { ITableParams } from "../../../common/interfaces.ts";
import { IResponsePaginateServices } from "../reducers";

export const getServices = (
  tableParams: ITableParams
): Promise<IResponsePaginateServices> => {
  return Axios.get("/agencies/services", {
    params: {
      perPage: tableParams.perPage,
      page: tableParams.currentPage,
      filter: tableParams.filter,
      filters: tableParams.filters,
      sorting: tableParams.sorting,
    },
  });
};

export const cancelService = (id: string) => {
  return Axios.delete(`/agency/service-cancel/${id}`);
};

export const deleteService = (id: string) => {
  return Axios.delete(`/agency/service/${id}`);
};
